
import { Modal, message } from "ant-design-vue";
const Message = message;



const setData = ({ commit }, params) => {
  commit("SET_DATA", params);
};

const setTabIndex =  ({ commit }, tabindex) => {
  commit("SET_TAB_INDEX", tabindex);
};



export default {
  setData,
  setTabIndex
};



// WEBPACK FOOTER //
// ./src/store/actions.js